import { create } from 'zustand';

export type HealthSyncStatus = 'idle' | 'syncing' | 'done' | 'error';

interface HealthSyncStatusState {
  status: HealthSyncStatus;
  lastSyncedAt: number | null;
  setStatus: (status: HealthSyncStatus) => void;
  setDone: (at: number) => void;
}

/**
 * Shared HealthKit sync status.
 *
 * `useHealthSync` keeps its own per-instance `syncing` boolean (unchanged),
 * but ALSO writes here so every consumer — the Profile indicator, Settings —
 * reflects the SAME real sync run, whichever hook instance started it.
 *
 * Throttled / no-op calls that return `null` synchronously never touch this
 * store, so a quick app-switch shows no spinner.
 */
export const useHealthSyncStatus = create<HealthSyncStatusState>((set) => ({
  status: 'idle',
  lastSyncedAt: null,
  setStatus: (status) => set({ status }),
  setDone: (at) => set({ status: 'done', lastSyncedAt: at }),
}));
